// import Dashboard from './Dashboard.vue';
// import Add from './Add.vue';
// import Edit from './Edit.vue';
import Main from "./Main.vue";


export default { Main };
